export default __webpack_public_path__ + "c16d5e66fd732f2a935354678a4d5ddf.svg";